import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const parentPath = '/orders/alerts/shiptogether';

const ShipTogetherWrapper = ({ alertID, combineOrderCount, customerName, closeModal }) => {
  const combineLink = `${parentPath}/${alertID}`;
  return (
    <React.Fragment>
      <FormattedMessage
        defaultMessage='<b>{combineOrderCount} open orders for</b> <l>{customerName}</l>. Consider combining these orders to save on shipping.'
        description='Ship Together Alert'
        id='GktLfu'
        values={{
          combineOrderCount,
          customerName,
          b: (chunks) => <b>{chunks}</b>,
          l: (chunks) => (
            <Link onClick={closeModal} to={combineLink}>
              {chunks}
            </Link>
          ),
        }}
      />
    </React.Fragment>
  );
};

ShipTogetherWrapper.propTypes = {
  alertID: PropTypes.string.isRequired,
  combineOrderCount: PropTypes.number.isRequired,
  customerName: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export const ShipTogether = injectIntl(ShipTogetherWrapper);
